import { render, staticRenderFns } from "./BaseOperacionesV2.vue?vue&type=template&id=6540cad4&"
import script from "./BaseOperacionesV2.vue?vue&type=script&lang=js&"
export * from "./BaseOperacionesV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports